// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Transfer payment'"></sub-header>

  <missing-access-warning
    missing-access="CST_DEPOSIT_ACCOUNT_READ">
  </missing-access-warning>

  <form name="\$ctrl.form">
    <form-section>

      <amortization-payment
        loan="\$ctrl.loan"
        payment-request="\$ctrl.paymentRequest"
        collect-official-receipt="true"
        custom-payment-allowed="\$ctrl.canPerformCustomPayment">
      </amortization-payment>

    </form-section>

    <form-section class="no-print" form-title="'transfer account'">
      <account-select required query-field="'id'" value-field="'id'"
                      field-mapping="{accountGroup: null, accountGroupMaxLength: null, name: 'name'}"
                      options="\$ctrl.accounts" ng-model="\$ctrl.selectedAccount"></account-select>
    </form-section>

    <div class="buttons">
      <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
      <button type="button" class="btn btn-print" ng-click="\$ctrl.print()">Print</button>
      <button type="button" class="btn btn-success" ng-disabled="\$ctrl.form.\$invalid || !\$ctrl.loan" ng-click="\$ctrl.pay()">
        Confirm payment
      </button>
    </div>

  </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/transfer-payment/loan-transfer-payment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;